var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, 1);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/succ.js
// module id = CJ2c
// module chunks = 0